export default __webpack_public_path__ + "static/media/error_page_background.19b16913.jpg";